import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import memo from "set-state-compare/build/memo"
import React from "react"
import Route from "@kaspernj/api-maker/build/router/route"
import Switch from "@kaspernj/api-maker/build/router/switch"
import {useWoofRouter} from "shared/woof-router"
export default memo(shapeComponent(class RoutesAdminCoursesRoute extends ShapeComponent {
  setup() {
    this.woofRouter = useWoofRouter()
  }

  render() {
    return (
      <Switch name="courses">
        <Route component="edit" exact path="new" />
        <Route exact path=":course_id/edit" />
        <Route exact path=":course_id/emails" />
        <Route component="course-modules" exact path=":course_id/course_modules" />
        <Route component="show" exact path=":course_id" />
        <Route component="index" exact />
        <Route componentPath="fallback" fallback onMatch={this.tt.onFallbackMatch} />
      </Switch>
    )
  }

  onFallbackMatch = () => this.woofRouter.setPageNotFound(true)
}))
